import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLeakDetectionHideEventHideConfDialog } from '@app/main/leak-detection/store/leak-detection-selection/leak-detection-selection.selectors';
import { setLeakDetectionHideEventHideConfDialog } from '@app/main/leak-detection/store/leak-detection-selection/leak-detection-selection.actions';

/** whether hiding an event still asks first — `Don't show this message again` turns it off for good (LD UI state) */
@Injectable({ providedIn: 'root' })
export class DialogEventHideConfService {
  private readonly store = inject(Store);

  private readonly hideConfDialog = this.store.selectSignal(selectLeakDetectionHideEventHideConfDialog);

  public isBlocked(): boolean {
    return this.hideConfDialog();
  }

  public block(): void {
    this.store.dispatch(setLeakDetectionHideEventHideConfDialog({ hideEventHideConfDialog: true }));
  }
}
